var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleaseOptionsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 14.7188C16.0309 14.7188 17.5 13.2497 17.5 11.4375C17.5 9.62532 16.0309 8.15625 14.2188 8.15625C12.4066 8.15625 10.9375 9.62532 10.9375 11.4375C10.9375 13.2497 12.4066 14.7188 14.2188 14.7188Z",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 27.8438C24.7809 27.8438 26.25 26.3747 26.25 24.5625C26.25 22.7503 24.7809 21.2812 22.9688 21.2812C21.1566 21.2812 19.6875 22.7503 19.6875 24.5625C19.6875 26.3747 21.1566 27.8438 22.9688 27.8438Z",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.4375H29.5313",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 11.4375H10.9375",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 24.5625H29.5312",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 24.5625H19.6875",
    stroke: "#42296E",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseOptionsIcon);
export default __webpack_public_path__ + "static/media/release_options_icon.8f5f3ee1e228cb2de2c7d8889e4b9b1b.svg";
export { ForwardRef as ReactComponent };